import tcs from '../assest/tcs.png';
import reliance from '../assest/reliance.png';
import hdfc from '../assest/hdfcbank.png';
import bharti from '../assest/bhartiartl.png';
import icici from '../assest/icicibank.png';
import infosys from '../assest/infy.png';
import sbi from '../assest/sbin.png';
import life from '../assest/lici.png';
import itc from '../assest/itc.png';
import hindustan from '../assest/hindunilvr.png';
import larsen from '../assest/Lt.png';
import hcl from '../assest/hcltech.png';
import bajaj from '../assest/bajajhfl.png';
import sun from '../assest/sunteck.png';
import mahindra from '../assest/mahabank.png';
import kotak from '../assest/kotakbank.png';
import axis from '../assest/axisbank.png';
import maruti from '../assest/maruti.png';
import ultratech from '../assest/ultracemco.png';
import ntpc from '../assest/ntpc.png';

export const screenerStockincomeData = [
  {
    symbol: "RELIANCE INDUSTRIES LTD",
    url: "/stockhandle",
    icon: reliance,
    revenue: "₹9.25T",
    revenueGrowth: "+6.37",
    grossProfit: "₹2.38T",
    operatingIncome: "₹1.08T",
    netIncome: "₹679.17B",
    ebitda: "₹1.61T",
    epsDil: "₹50.19",
    epsDilGrowth: "-0.85",
    pToE: "20.50",
    pToB: "3.40",
    peg: "1.50",
    pToS: "2.50",
    pToCF: "2.10",
    sector: "Energy",
    price: "₹2,500",
    ev: "₹10,000",
    evEbitda: "15.20",
    evSales: "2.80",
    evEbit: "12.00",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "TATA CONSULTANCY SERVICES LTD.",
    url: "/stockhandle",
    icon: tcs,
    revenue: "₹2.49T",
    revenueGrowth: "+5.17",
    grossProfit: "₹780.25B",
    operatingIncome: "₹619.8B",
    netIncome: "₹474.41B",
    ebitda: "₹669.45B",
    epsDil: "₹130.85",
    epsDilGrowth: "+7.22",
    pToE: "28.00",
    pToB: "8.00",
    peg: "2.00",
    pToS: "5.50",
    pToCF: "4.20",
    sector: "IT Services",
    price: "₹3,500",
    ev: "₹8,000",
    evEbitda: "22.00",
    evSales: "6.00",
    evEbit: "18.00",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "HDFC BANK LTD",
    icon: hdfc,
    revenue: "₹1.6T",
    revenueGrowth: "+10.12",
    grossProfit: "₹1.2T",
    operatingIncome: "₹760.45B",
    netIncome: "₹500.3B",
    ebitda: "₹950B",
    epsDil: "₹70.58",
    epsDilGrowth: "+12.5",
    pToE: "25.00",
    pToB: "4.50",
    peg: "1.50",
    pToS: "4.00",
    pToCF: "3.50",
    sector: "Banking",
    price: "₹1,800",
    ev: "₹6,000",
    evEbitda: "18.00",
    evSales: "3.50",
    evEbit: "14.00",
    index: "Nifty  Smallcap 100",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "NTPC LTD",
    icon: ntpc,
    revenue: "₹1.6T",
    revenueGrowth: "+6.8",
    grossProfit: "₹900B",
    operatingIncome: "₹580.5B",
    netIncome: "₹410.2B",
    ebitda: "₹700.6B",
    epsDil: "₹45.4",
    epsDilGrowth: "+5.6",
    pToE: "12.50",
    pToB: "1.90",
    peg: "1.10",
    pToS: "1.50",
    pToCF: "1.40",
    sector: "Utilities",
    price: "₹150",
    ev: "₹70",
    evEbitda: "9.20",
    evSales: "1.60",
    evEbit: "7.80",
    index: "Nifty 50",
    marketCapCategory: "Mid Cap",
  },

  {
    symbol: "BHARTI AIRTEL LTD",
    icon: bharti,
    revenue: "₹1.45T",
    revenueGrowth: "+8.6",
    grossProfit: "₹680.3B",
    operatingIncome: "₹300.4B",
    netIncome: "₹150.2B",
    ebitda: "₹520.3B",
    epsDil: "₹40.65",
    epsDilGrowth: "+5.3",
    pToE: "22.00",
    pToB: "3.00",
    peg: "1.80",
    pToS: "2.50",
    pToCF: "2.30",
    sector: "Telecom",
    price: "₹750",
    ev: "₹1,200",
    evEbitda: "10.20",
    evSales: "3.00",
    evEbit: "12.00",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "ICICI BANK LTD",
    icon: icici,
    revenue: "₹1.88T",
    revenueGrowth: "+9.25",
    grossProfit: "₹1.1T",
    operatingIncome: "₹890.2B",
    netIncome: "₹620.45B",
    ebitda: "₹750B",
    epsDil: "₹75.12",
    epsDilGrowth: "+9.75",
    pToE: "24.00",
    pToB: "3.80",
    peg: "1.40",
    pToS: "3.20",
    pToCF: "2.80",
    sector: "Banking",
    price: "₹1,020",
    ev: "₹4,000",
    evEbitda: "12.50",
    evSales: "2.80",
    evEbit: "10.50",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "INFOSYS LTD",
    icon: infosys,
    revenue: "₹1.4T",
    revenueGrowth: "+6.98",
    grossProfit: "₹720.4B",
    operatingIncome: "₹500.2B",
    netIncome: "₹430.7B",
    ebitda: "₹590.1B",
    epsDil: "₹60.75",
    epsDilGrowth: "+8.25",
    pToE: "30.00",
    pToB: "7.50",
    peg: "2.10",
    pToS: "4.50",
    pToCF: "3.80",
    sector: "IT Services",
    price: "₹1,600",
    ev: "₹5,000",
    evEbitda: "20.00",
    evSales: "5.50",
    evEbit: "16.50",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "STATE BANK OF INDIA",
    icon: sbi,
    revenue: "₹3.2T",
    revenueGrowth: "+11.02",
    grossProfit: "₹2.1T",
    operatingIncome: "₹1.5T",
    netIncome: "₹960.3B",
    ebitda: "₹1.75T",
    epsDil: "₹85.32",
    epsDilGrowth: "+10.15",
    pToE: "18.00",
    pToB: "2.50",
    peg: "1.20",
    pToS: "2.20",
    pToCF: "2.00",
    sector: "Banking",
    price: "₹600",
    ev: "₹10,000",
    evEbitda: "14.20",
    evSales: "2.60",
    evEbit: "11.30",
    index: "Nifty 50",
    marketCapCategory: "Mid Cap",
  },
  {
    symbol: "LIFE INSURANCE CORPORATION OF INDIA",
    icon: life,
    revenue: "₹2.7T",
    revenueGrowth: "+7.12",
    grossProfit: "₹1.5T",
    operatingIncome: "₹1.02T",
    netIncome: "₹580.4B",
    ebitda: "₹1.15T",
    epsDil: "₹90.2",
    epsDilGrowth: "+5.45",
    pToE: "12.50",
    pToB: "1.80",
    peg: "1.00",
    pToS: "2.00",
    pToCF: "1.70",
    sector: "Insurance",
    price: "₹680",
    ev: "₹11,000",
    evEbitda: "15.00",
    evSales: "2.50",
    evEbit: "13.00",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "ITC LTD",
    icon: itc,
    revenue: "₹680.4B",
    revenueGrowth: "+9.4",
    grossProfit: "₹350.5B",
    operatingIncome: "₹280.3B",
    netIncome: "₹200.2B",
    ebitda: "₹310.6B",
    epsDil: "₹35.85",
    epsDilGrowth: "+6.12",
    pToE: "22.00",
    pToB: "5.00",
    peg: "1.90",
    pToS: "4.00",
    pToCF: "3.80",
    sector: "FMCG",
    price: "₹450",
    ev: "₹4,500",
    evEbitda: "14.50",
    evSales: "3.50",
    evEbit: "12.50",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "HINDUSTAN UNILEVER LTD",
    icon: hindustan,
    revenue: "₹560.3B",
    revenueGrowth: "+7.75",
    grossProfit: "₹340.2B",
    operatingIncome: "₹250.3B",
    netIncome: "₹180.6B",
    ebitda: "₹290.8B",
    epsDil: "₹30.6",
    epsDilGrowth: "-0.16",
    pToE: "35.00",
    pToB: "10.00",
    peg: "2.50",
    pToS: "5.50",
    pToCF: "4.50",
    sector: "FMCG",
    price: "₹2,000",
    ev: "₹6,000",
    evEbitda: "20.50",
    evSales: "6.00",
    evEbit: "18.00",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "LARSEN & TOUBRO LTD",
    icon: larsen,
    revenue: "₹1.6T",
    revenueGrowth: "+8.5",
    grossProfit: "₹950.6B",
    operatingIncome: "₹600.8B",
    netIncome: "₹420.4B",
    ebitda: "₹750.7B",
    epsDil: "₹70.45",
    epsDilGrowth: "+9.65",
    pToE: "20.00",
    pToB: "2.70",
    peg: "1.50",
    pToS: "3.50",
    pToCF: "3.20",
    sector: "Engineering",
    price: "₹2,500",
    ev: "₹10,000",
    evEbitda: "13.50",
    evSales: "3.20",
    evEbit: "11.70",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "HCL TECHNOLOGIES LTD",
    icon: hcl,
    revenue: "₹950B",
    revenueGrowth: "+6.4",
    grossProfit: "₹480B",
    operatingIncome: "₹360.2B",
    netIncome: "₹300.4B",
    ebitda: "₹450.6B",
    epsDil: "₹55.3",
    epsDilGrowth: "+8.7",
    pToE: "20.00",
    pToB: "4.50",
    peg: "1.40",
    pToS: "3.20",
    pToCF: "3.10",
    sector: "Technology",
    price: "₹1,150",
    ev: "₹5,500",
    evEbitda: "12.80",
    evSales: "2.80",
    evEbit: "11.30",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "BAJAJ FINANCE LTD",
    icon: bajaj,
    revenue: "₹390.5B",
    revenueGrowth: "+12.5",
    grossProfit: "₹180.7B",
    operatingIncome: "₹140.3B",
    netIncome: "₹110.2B",
    ebitda: "₹150.8B",
    epsDil: "₹180.4",
    epsDilGrowth: "+9.2",
    pToE: "28.00",
    pToB: "6.50",
    peg: "1.80",
    pToS: "4.10",
    pToCF: "4.00",
    sector: "Finance",
    price: "₹6,000",
    ev: "₹10,500",
    evEbitda: "14.20",
    evSales: "2.60",
    evEbit: "13.00",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "SUNTECK REALTY LTD",
    icon: sun,
    revenue: "₹50.2B",
    revenueGrowth: "+6.8",
    grossProfit: "₹25.1B",
    operatingIncome: "₹15.4B",
    netIncome: "₹10.5B",
    ebitda: "₹18.7B",
    epsDil: "₹12.3",
    epsDilGrowth: "+5.4",
    pToE: "25.00",
    pToB: "2.80",
    peg: "1.50",
    pToS: "3.00",
    pToCF: "2.90",
    sector: "Real Estate",
    price: "₹400",
    ev: "₹500",
    evEbitda: "16.00",
    evSales: "3.50",
    evEbit: "12.00",
    index: "Nifty Realty",
    marketCapCategory: "Small Cap",
  },
  {
    symbol: "MAHINDRA & MAHINDRA LTD",
    icon: mahindra,
    revenue: "₹1.2T",
    revenueGrowth: "+10.4",
    grossProfit: "₹540.8B",
    operatingIncome: "₹360.2B",
    netIncome: "₹270.6B",
    ebitda: "₹430.3B",
    epsDil: "₹75.5",
    epsDilGrowth: "+7.8",
    pToE: "22.00",
    pToB: "4.00",
    peg: "1.30",
    pToS: "3.50",
    pToCF: "3.20",
    sector: "Automotive",
    price: "₹1,500",
    ev: "₹8,000",
    evEbitda: "14.00",
    evSales: "2.80",
    evEbit: "12.50",
    index: "Nifty Auto",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "KOTAK MAHINDRA BANK LTD",
    icon: kotak,
    revenue: "₹900.7B",
    revenueGrowth: "+8.7",
    grossProfit: "₹500.5B",
    operatingIncome: "₹380.6B",
    netIncome: "₹280.4B",
    ebitda: "₹450.8B",
    epsDil: "₹60.2",
    epsDilGrowth: "+9.5",
    pToE: "24.00",
    pToB: "3.50",
    peg: "1.20",
    pToS: "3.20",
    pToCF: "3.00",
    sector: "Finance",
    price: "₹2,000",
    ev: "₹7,000",
    evEbitda: "13.80",
    evSales: "2.70",
    evEbit: "12.40",
    index: "Nifty Bank",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "AXIS BANK LTD",
    icon: axis,
    revenue: "₹1.7T",
    revenueGrowth: "+9.2",
    grossProfit: "₹890B",
    operatingIncome: "₹720.5B",
    netIncome: "₹520.6B",
    ebitda: "₹1T",
    epsDil: "₹60.5",
    epsDilGrowth: "+10.5",
    pToE: "18.00",
    pToB: "2.50",
    peg: "1.00",
    pToS: "2.50",
    pToCF: "2.20",
    sector: "Banking",
    price: "₹850",
    ev: "₹5,500",
    evEbitda: "11.50",
    evSales: "2.20",
    evEbit: "10.80",
    index: "Nifty Bank",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "MARUTI SUZUKI INDIA LTD",
    icon: maruti,
    revenue: "₹1.3T",
    revenueGrowth: "+10.3",
    grossProfit: "₹720B",
    operatingIncome: "₹540.1B",
    netIncome: "₹390.2B",
    ebitda: "₹660.5B",
    epsDil: "₹130.4",
    epsDilGrowth: "+7.75",
    pToE: "30.00",
    pToB: "4.50",
    peg: "1.50",
    pToS: "3.80",
    pToCF: "3.70",
    sector: "Automotive",
    price: "₹9,000",
    ev: "₹15,000",
    evEbitda: "15.00",
    evSales: "3.00",
    evEbit: "13.00",
    index: "Nifty Auto",
    marketCapCategory: "Large Cap",
  },
  {
    symbol: "ULTRATECH CEMENT LTD",
    icon: ultratech,
    revenue: "₹710.4B",
    revenueGrowth: "+8.6",
    grossProfit: "₹350.2B",
    operatingIncome: "₹280.6B",
    netIncome: "₹190.5B",
    ebitda: "₹300.7B",
    epsDil: "₹90.1",
    epsDilGrowth: "+6.8",
    pToE: "35.00",
    pToB: "6.00",
    peg: "2.00",
    pToS: "4.20",
    pToCF: "4.00",
    sector: "Cement",
    price: "₹8,000",
    ev: "₹18,000",
    evEbitda: "16.00",
    evSales: "4.00",
    evEbit: "14.00",
    index: "Nifty 50",
    marketCapCategory: "Large Cap",
  },
];
